import { GameData } from "../../server/data/GameData";
import { Presentation } from "../../../core/gameflow/controller/Presentation";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Beheaded } from "../../Beheaded";

export class ZeroBetPresentation extends Presentation {

    private ammFSLeft:number = 0;
    private preReduce:boolean = false;

    setGamedData(data: GameData): void {
        this.ammFSLeft = data.raw.freespinsLeft;
        this.preReduce = !data.Win.singleWin;
    }

    public createPresentation(enableSkip: Function) {

        this.PresentationState.setInactive();
    }

    done(): void {
        if(this.ammFSLeft == undefined || !this.ammFSLeft){
            SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        }else{
            const amm = this.ammFSLeft - (this.preReduce ? 1 : 0)
            SlotGame.keypadPlugin.setZeroBetSpinCounter(!amm ? -1 : amm);
        }
        SlotGame.apiPlugin.betHandler.zeroBet();
    }
}
